// @flow

import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, Button } from "react-bootstrap";
import auth from "../../services/auth";
import { userActions } from "../../redux/actions/user";
import Popup from "react-popup";
import { history } from "../../redux/store/configureStore";
import { Redirect } from "react-router-dom";
import Messaging from "./Messaging";
import imageURL from "../../img/ddb-logo.png";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      login_token: "",
      logout_response: "",
      submitted: false,
      login_response: "",
      alert: false,
      errmsg: ""
    };
  }
  state = {
    redirectToReferrer: false
  };

  isAuthenticated() {
    const token = auth.getToken();
    return token && token.length > 10;
  }

  renderAlert() {
    if (this.state.alert) {
      return (
        <div className="alert alert-danger">
          <strong>Alert!</strong> {this.state.errmsg}
        </div>
      );
    }
    return null;
  }

  render() {
    const { email, password, submitted } = this.state;
    const { isLogging } = this.props;
    const { user } = this.props;
    const { state, actions } = this.props;
    const isAlreadyAuthenticated = this.isAuthenticated();

    return (
      <div className="content">
        {isAlreadyAuthenticated ? (
          <Redirect to={{ pathname: "./home" }} />
        ) : (
          <Row>
            <Col md={4} mdOffset={4} xs={10} xsOffset={1}>
              <form className="form-horizontal" noValidate>
                <fieldset>
                  <legend className="text-center">
                    <h1>
                      <img src={imageURL} width="45%" />
                    </h1>
                    <h2>Login</h2>
                  </legend>
                  <Messaging />
                  {this.renderAlert()}
                  <div className="form-group">
                    <label
                      htmlFor="inputEmail"
                      className="col-lg-2 control-label"
                    >
                      Email
                    </label>
                    <div className="col-lg-10">
                      <input
                        type="email"
                        className="form-control"
                        id="inputEmail"
                        placeholder="Email"
                        value={email}
                        onChange={this.handlesOnEmailChange}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label
                      htmlFor="inputPassword"
                      className="col-lg-2 control-label"
                    >
                      Password
                    </label>
                    <div className="col-lg-10">
                      <input
                        type="password"
                        className="form-control"
                        id="inputPassword"
                        placeholder="Password"
                        value={password}
                        onChange={this.handlesOnPasswordChange}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <Col lg={10} lgOffset={2}>
                      <Button
                        type="submit"
                        className="login-button btn-block"
                        bsStyle="primary"
                        disabled={isLogging}
                        onClick={this.handlesOnLogin.bind(this)}
                      >
                        {isLogging ? (
                          <span>
                            login in... &nbsp;
                            <i className="fa fa-spinner fa-pulse fa-fw" />
                          </span>
                        ) : (
                          <span>Login</span>
                        )}
                      </Button>
                    </Col>
                  </div>
                </fieldset>
              </form>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={4} mdOffset={4} xs={10} xsOffset={1}>
            <div className="pull-right">
            </div>
          </Col>
        </Row>
      </div>
    );
  }
  // #endregion

  // #region form inputs change callbacks
  handlesOnEmailChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      // should add some validator before setState in real use cases
      this.setState({ email: event.target.value.trim() });
    }
  };

  handlesOnPasswordChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      // should add some validator before setState in real use cases
      this.setState({ password: event.target.value.trim() });
    }
  };
  // #endregion

  // #region on login button click callback
  handlesOnLogin = async (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({ submitted: true });
    const { email, password } = this.state;
    const { dispatch } = this.props;

    const { history, login } = this.props;

    try {
      if (email && password) {
        dispatch(userActions.login(email, password, 'superadmin'));
        // this.props.login(email,password);
        this.setState({ alert: false });
        this.setState({ errmsg: "" });
      } else {
        this.setState({ alert: true });
        this.setState({ errmsg: "Email and Password fields are required" });
      }
    } catch (error) {
      this.setState({ alert: true });
      this.setState({ errmsg: error /*'Invalid Login Credential'*/ });
      /* eslint-enable no-console */
    }
  };
  // #endregion

  // #region on go back home button click callback
  goHome = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
    }
    const { history } = this.props;
    history.push({ pathname: "/" });
  };
  // #endregion
}

export default Login;



// WEBPACK FOOTER //
// ./src/app/views/login/Login.js